import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//icons
import { BsSearch } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
//api
import { getAllDiscountCoupons } from 'api/products';
//helpers
import { formatDateToSpanish } from 'helpers';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import ButtonCustom from 'components/backoffice/buttonCustom';

const colsCoupons = [
  'Nombre del cupón',
  'Descuento',
  'Tipo',
  'Estado',
  'Fecha de inicio',
  'Fecha de caducidad',
  ''
];

const Coupons = () => {
  const navigate = useNavigate();
  const [listCoupons, setListCoupons] = useState([]);
  const [noResults, setNoResults] = useState(false);

  const query = {
    coupon: '',
    type_discount: '',
    is_active: '',
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListCoupons = async () => {
    const { data, status } = await getAllDiscountCoupons(queryString);
    if (status === 200) {
      setListCoupons(data?.results);
      setNoResults(data?.results.length === 0);
    } else {
      setListCoupons([]);
      setNoResults(true);
    }
  };

  useEffect(() => {
    getListCoupons();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/coupons');
  };

  return (
    <div className="h-100 ml-70">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Cupones</h1>
      </div>
      <div className="d-flex my-5">
        <CustomInput
          //handleSubmit={(e) => handleSubmit(e)}
          placeholder="Buscar por nombre "
          icon={<BsSearch color="#161A25" className="icon-search" />}
          type={'search'}
        />
        <ButtonCustom onClick={handleClear} color="terciary">
          <GiBroom />
        </ButtonCustom>
      </div>
      <CustomTable cols={colsCoupons} noResults={noResults} className="custom-table" page={2}>
        {listCoupons &&
          listCoupons.map((listCoupon, index) => {
            return (
              <tr key={listCoupon.id}>
                <td>{listCoupon.coupon}</td>
                <td>{parseInt(listCoupon.discount)}</td>
                <td>{listCoupon.type_discount == 0 ? 'Porcentaje' : 'Monto fijo'}</td>
                <td>{formatDateToSpanish(listCoupon.valid_from)}</td>
                <td>{formatDateToSpanish(listCoupon.valid_until)}</td>
                <td className="item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default Coupons;
